import TaxRateCaptureSettingAddForm from './TaxRateCaptureSettingAddForm';

export default TaxRateCaptureSettingAddForm;
